const isArray = (value): boolean => Array.isArray(value)
const isString = (value): boolean => typeof value === 'string' && !isNull(value) && !isUndefined(value)
const isNumber = (value): boolean => typeof value === 'number' && !isNull(value) && !isUndefined(value) && !isNan(Number(value))
const isBoolean = (value): boolean => typeof value === 'boolean' && !isNull(value) && !isUndefined(value)
const isObject = (value): boolean => typeof value === 'object' && !isNull(value) && !isUndefined(value)
const isFunction = (value): boolean => typeof value === 'function' && !isNull(value) && !isUndefined(value)
const isSymbol = (value): boolean => typeof value === 'symbol' && !isNull(value) && !isUndefined(value)
const isUndefined = (value): boolean => value === undefined && !isNull(value) 
const isNull = (value): boolean => value === null  && !isUndefined(value)
const isNan = (value): boolean => Number.isNaN(Number(value))
const isArrayEmpty = (array: any[]): boolean => isArray(array) && !array?.length
const isFile = (value): boolean => value instanceof File
const minLength = (value: any[], min: number): boolean => value.length >= min
const maxLength = (value: any[], max: number): boolean => value.length <= max
const isMail = (value: string): boolean => {const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; return emailRegex.test(value)}
const isPasswordsMatched = (password: string, confirmPassword: string): boolean => password != confirmPassword
const isHaveValue = (value): boolean => isString(value) || isNumber(value) || isBoolean(value) || isObject(value) || isFunction(value) || isSymbol(value) || isArray(value) && value?.length > 0
const isTel = (value: string): boolean => { const phoneRegex = /^[\+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{1,6}[-\s\.]?[0-9]{1,6}$/; return phoneRegex.test(value)}
const isAr = (value: string): boolean => { const arRegex = /^[\u0600-\u06FF\u0750-\u077F]+$/; return arRegex.test(value)}
const isEn = (value: string): boolean => { const enRegex = /^[a-zA-Z]+$/; return enRegex.test(value)}

export const Validations = {
    isString,
    isNumber,
    isBoolean,
    isObject,
    isFunction,
    isSymbol,
    isUndefined,
    isNull,
    isFile,
    isNan,
    isArray,
    isArrayEmpty,
    isHaveValue,
    isPasswordsMatched, 
    minLength,
    maxLength,
    isMail,
    isTel,
    isAr,
    isEn
}